// extracted by mini-css-extract-plugin
export default {"salesListContainer":"SalesList_salesListContainer__mAT3D","salesListItem":"SalesList_salesListItem__rJad+","createdAt":"SalesList_createdAt__IhIrm"};